export const DEFAULT_FRONTEND_PREVIEW_BASE_URL = "";

export const FRONTEND_PREVIEW_BASE_URL = (
  process.env.REACT_APP_FRONTEND_PREVIEW_BASE_URL || DEFAULT_FRONTEND_PREVIEW_BASE_URL
).trim();

// Keep the preview host isolated: scripts can run, but same-origin access, forms,
// popups, top navigation, and downloads stay blocked unless explicitly revisited.
export const PREVIEW_IFRAME_SANDBOX = "allow-scripts";

export function buildFrontendPreviewUrl({ componentId, scenarioId, baseUrl = FRONTEND_PREVIEW_BASE_URL }) {
  if (!baseUrl || !componentId || !scenarioId) return "";

  const separator = baseUrl.includes("?") ? "&" : "?";
  const params = new URLSearchParams({
    componentId,
    scenarioId
  });

  return `${baseUrl}${separator}${params.toString()}`;
}
